export enum ActiveStatus {
  Active = "active",
  Inactive = "inactive",
  Suspended = "suspended",
  Pending = "pending",
}

export enum ChargeType {
  Miscellaneous = "misc",
  TripMinimum = "tripmin",
  LocationDiscount = "location-discount",
  LocationFee = "location-fee",
  Wash = "wash",
}

export enum Role {
  SuperAdmin = "SADM",
  Admin = "ADM",
  Lead = "LEAD",
  Customer = "CUST",
}

export enum ReportType {
  AccountActivity = "AccountActivity",
  WashDetails = "WashDetails",
  Lead = "Lead",
  KPIReport = "KPIReport",
}

export enum StatusCodes {
  NotFound = 404,
  Forbidden = 403,
}

export enum FileUploadStatus {
  NotStarted = "not-started",
  InProgress = "in-progress",
  Completed = "completed",
  Failed = "failed",
}

export enum CreateInvoiceStatus {
  CreationStarted = "creation-started",
  RegenerationStarted = "re-generation-started",
  PdfGenerated = "pdf-generated",
  NotStarted = "not-started",
  InProgress = "in-progress",
  Failed = "failed",
}

export enum InvoiceStatus {
  All = "all",
  Pending = "pending",
  SendToCustomer = "send-to-customer",
  SendToQuickbooks = "send-to-quickbooks",
  Cancelled = "cancelled",
  Deleted = "deleted",
  OnHold = "on-hold",
  PaymentReceived = "payment-received",
  InProgress = "in-progress",
}

export enum UserStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum Module {
  AccountList = "account-list",
  AccountBasic = "account-basic",
  AccountContacts = "account-contacts",
  AccountFinancial = "account-financial",
  AccountFleet = "account-fleet",
  AccountLocation = "account-location",
  AccountPricing = "account-pricing",
  AdminDashboard = "admin-dashboard",
  All = "all",
  CustomerDashboard = "customer-dashboard",
  InvoiceList = "invoice-list",
  Invoice = "invoice",
  InvoiceNotes = "invoice-notes",
  ModuleList = "module-list",
  Module = "module",
  OrganizationList = "organization-list",
  Organization = "organization",
  Payment = "payment",
  RoleList = "role-list",
  Role = "role",
  SuperAdminDashboard = "super-admin-dashboard",
  UserList = "user-list",
  User = "user",
  WashInventoryList = "wash-inventory-list",
  WashInventory = "wash-inventory",
  WashTypeList = "wash-type-list",
  WashType = "wash-type",
  WashDetailsReport = "wash-details=report",
  AccountActivityReport = "account-activity-report",
  KPIReport = "kpi-report",
  Notification = "notification",
  WashNote = "wash-note",
}

export enum Action {
  Read = "read",
  Write = "write",
  Delete = "delete",
  All = "all",
}

export enum InvoicePaymentDisplayStatus {
  Overdue = "Past Due",
  WithinDue = "Not Paid",
  Paid = "Paid",
  TransactionInitiated = "Transaction Initiated",
}

export enum InvoicePaymentStatus {
  FullyPaid = "fully-paid",
  PartiallyPaid = "partially-paid",
  Overdue = "overdue",
  Unpaid = "unpaid",
}

export enum PaymentMethod {
  Ach = "ach",
  Cash = "cash",
  Check = "check",
  Card = "card",
}

export enum PaymentSource {
  New = "NEW",
  Saved = "SAVED",
}

export enum TokenType {
  Card = "card",
  Ach = "ach",
}

export enum InvoicePaymentCallbackMessage {
  Cancelled = "cancelled",
  PaymentSuccess = "payment-success",
  None = "none",
}

export enum DateRangeOptions {
  Today = "today",
  Yesterday = "yesterday",
  ThisWeek = "thisWeek",
  LastWeek = "lastWeek",
  ThisMonth = "thisMonth",
  LastMonth = "lastMonth",
  ThisQuarter = "thisQuarter",
  LastQuarter = "lastQuarter",
  Last6Months = "last6Months",
  Last12Months = "last12Months",
  ThisYear = "thisYear",
  CustomDate = "customDate",
}

export enum PaymentStatus {
  All = "all",
  TransactionInitiated = "transaction-initiated",
  TransactionFailed = "transaction-failed",
  TransactionCancelled = "transaction-cancelled",
  PaymentSuccess = "payment-success",
  PaymentFailed = "payment-failed",
  ReturnInitiated = "return-initiated",
  ReturnSuccess = "return-success",
  ReturnFailed = "return-failed",
  ReversalInitiated = "reversal-initiated",
  ReversalSuccess = "reversal-success",
  ReversalFailed = "reversal-failed",
}

export enum TransactionType {
  All = "all",
  Sale = "sale",
  Reversal = "reversal",
  Refund = "refund",
}
export enum AdjustmentValueType {
  Flat = "flat",
  Percentage = "percentage",
}

export enum AdjustmentType {
  invoiceFee = "invoice-fee",
  invoiceDiscount = "invoice-discount",
}

export enum Features {
  KPI_REPORT = "isKPIReportEnabled",
  DASHBOARD = "isDashboardEnabled",
}
